import { gql } from '@apollo/client';

const INITIALIZE_ORDER_HISTORY_DOWNLOAD = gql`
  mutation InitOrderFileDownload($orderRowId: ID!) {
    initOrderFileDownload(orderRowId: $orderRowId)
  }
`;

export default INITIALIZE_ORDER_HISTORY_DOWNLOAD;
